package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Flashcard(
  public val id: String,
  public val skill_id: String?,
  public val front: String,
  public val back: String,
  public val note: String?,
  public val box: Long,
  public val due_date: String,
  public val last_review: String?,
  public val reviews: Long,
  public val lapses: Long,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
